import { render, staticRenderFns } from "./PrepCatalog.vue?vue&type=template&id=3c378c24&scoped=true"
import script from "./PrepCatalog.vue?vue&type=script&lang=js"
export * from "./PrepCatalog.vue?vue&type=script&lang=js"
import style0 from "./PrepCatalog.vue?vue&type=style&index=0&id=3c378c24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c378c24",
  null
  
)

export default component.exports